/* 🤖 this file was generated by svg-to-ts */
export const matIconDataArray: {
  name: 'data-array';
  data: string;
} = {
  name: 'data-array',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z"/></svg>`
};
